"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenseTab = void 0;
const store_1 = require("client/modules/orders/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const order_claims_1 = require("../../components/order-claims");
let DispenseTab = class DispenseTab extends react_1.Component {
    render() {
        const orderId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "order__form" },
            React.createElement(order_claims_1.OrderClaims, { ref: this.props.forwardedRef, order: orderId ? store_1.ordersStore.order.value : null, isClaimChecked: this.props.isClaimChecked, handleClaimChanged: this.props.handleClaimChanged, handleClaimSelected: this.props.handleClaimSelected, handleCheckAllClaims: this.props.handleCheckAllClaims, isAllClaimsChecked: this.props.isAllClaimsChecked, indeterminate: this.props.indeterminate, loading: store_1.ordersStore.claimsGroup.loading })));
    }
};
DispenseTab = __decorate([
    mobx_react_1.observer
], DispenseTab);
exports.DispenseTab = DispenseTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/tabs/dispense/dispense.tsx
// module id = 3753
// module chunks = 0